<template>
	<div class="app-data-card">
		<AppImage
			v-if="icon || fallback"
			class="app-data-card__icon"
			:src="icon"
			:fallback="fallback"
		/>

		<div class="app-data-card__details">
			<div class="app-data-card__value" v-if="value">{{ value }}</div>
			<div class="app-data-card__name" v-else>{{ noDisplay ? '' : $t('no_data') }}</div>
			<div class="app-data-card__name">{{ name }}</div>
			<div class="app-data-card__description">
				<AppImage v-if="descriptionIcon" class="app-data-card__description_icon" :src="descriptionIcon"/>
				<h5>{{ description }}</h5>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: [
		'icon',
		'value',
		'name',
		'fallback',
		'description',
		'descriptionIcon',
		'noDisplay'
	]
}
</script>

<style lang="scss" scoped>
.app-data-card {
	box-shadow: 0 2px 6px #00000026;
	border-radius: 5px;
	padding: 10px 20px;
	display: flex;
	align-items: center;
	background-color: #fff;

	&__icon {
		flex-shrink: 0;
		width: 30px;
		height: 30px;
		margin-right: 10px;
	}

	&__details {
		flex: 1 1 auto;
	}

	&__value {
		font-size: 1em;
		color: $default;
		font-weight: 600;
		margin-bottom: .10px;
	}

	&__name {
        font-family: 'Quicksand', sans-serif;
        font-weight: 600;
        font-size: 16px;
	}

	&__description{
		font-size: .5em;
		color: $default-light;

        display: flex;
        justify-content: center;
	}

	&__description_icon{
		width: 30px;
        margin-right: 10px;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/app-components/AppDataCard.vue